/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Exampreparationinformation2Inputs */

const de__field_exampreparationinformation2 = /** @type {(inputs: _Field_Exampreparationinformation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfungsvorbereitung`)
};

/**

* @param {_Field_Exampreparationinformation2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_exampreparationinformation2 = /** @type {((inputs?: _Field_Exampreparationinformation2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Exampreparationinformation2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_exampreparationinformation2(inputs)
});
export { _field_exampreparationinformation2 as "_field_examPreparationInformation" }